import { Toolbar } from 'primereact/toolbar';
import React from 'react';
import LanguageToggle from '../components/LanguageToggle';

interface PartnerPageProps {
    title: string;
    end?: React.ReactNode;
    onExpire?: () => void;
}

const PartnerFrame: React.FC<PartnerPageProps> = (props: PartnerPageProps) => {
    const start = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={"/" + process.env.REACT_APP_LOGO} alt="logo" style={{ height: '2rem'}} className='mr-3'/>

            <span className="text-xl font-bold ml-3" style={{ color: 'var(--primary-color-text)' }}>
                {props.title}
            </span>
        </div>
    );

    const end = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {props.end}
            <LanguageToggle />
        </div>
    );

    return (
            <Toolbar
                start={start}
                end={end}
                className="fixed top-0 left-0 w-full z-5 p-toolbar custom-toolbar"
            />
    );
};

export default PartnerFrame;
